export default "__VITE_ASSET__Cv2LojKU__"